import styled from 'styled-components'

import { MEDIA_QUERIES } from '@/ui/constants/mediaQueries'

export const TipContainer = styled.div`
  display: flex;
  justify-content: center;
`
export const TipIcon = styled.div(
  ({ theme }) => `
      align-items: center;
      background-color: ${theme.colors.purple.light5};
      border-radius: ${theme.borderRadius.rounded};
      display: flex;
      flex-shrink: 0;
      height: 4.8rem;
      justify-content: center;
      margin-right: ${theme.spacing.defaultSmall};
      width: 4.8rem;

      svg {
        height: ${theme.spacing.large};
      }
      `
)

export const TipTextContainer = styled.div(
  ({ theme }) => `
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 17rem;

  button {
    text-align: left;
  }

  ${MEDIA_QUERIES(theme).large}{
    max-width: none;
  }
`
)
